import { gql } from "@apollo/client";
import { companyFragment } from "./company";

export const FullBsdaTransporterFragment = gql`
  fragment FullBsdaTransporter on BsdaTransporter {
    id
    company {
      ...CompanyFragment
    }
    customInfo
    recepisse {
      number
      department
      validityLimit
      isExempted
    }
    transport {
      mode
      plates
      takenOverAt
      signature {
        author
        date
      }
    }
  }
  ${companyFragment}
`;

export const bsdaFragment = gql`
  fragment BsdaFragment on Bsda {
    id
    bsdaType: type
    isDraft
    bsdaStatus: status
    emitter {
      isPrivateIndividual
      company {
        name
        siret
        orgId
      }
      pickupSite {
        name
      }
    }
    destination {
      company {
        name
        siret
        orgId
      }
      reception {
        weight
        acceptedWeight
      }
      operation {
        nextDestination {
          company {
            orgId
          }
        }
      }
      cap
    }
    worker {
      isDisabled
      company {
        name
        siret
        orgId
      }
    }
    ecoOrganisme {
      name
      siret
    }
    transporter {
      id
      company {
        name
        siret
        orgId
      }
      customInfo
      recepisse {
        number
        department
        validityLimit
        isExempted
      }
      transport {
        plates
        signature {
          date
        }
      }
    }
    transporters {
      id
      company {
        name
        siret
        orgId
      }
      customInfo
      recepisse {
        number
        department
        validityLimit
        isExempted
      }
      transport {
        plates
        mode
        signature {
          date
        }
      }
    }
    waste {
      materialName
      bsdaCode: code
    }
    # Attention, pour des raisons de performance, seul
    # l'identifiant est exposé ici. Requêter d'autres champs sur
    # forwardedIn ne fonctionnera pas
    forwardedIn {
      id
    }
    # Attention, pour des raisons de performance, seul
    # l'identifiant est exposé ici. Requêter d'autres champs sur
    # groupedIn ne fonctionnera pas
    groupedIn {
      id
    }
    weight {
      value
    }
    bsdaUpdatedAt: updatedAt
    metadata {
      latestRevision {
        id
        status
        authoringCompany {
          siret
          name
        }
        approvals {
          approverSiret
          status
        }
      }
    }
  }
`;

// This fragment query only the fields required for dashboard and workflow action button
// Would you need to query more fields, pay attention to sub resolvers which
// might make unwanted db queries
export const dashboardBsdaFragment = gql`
  fragment DashboardBsdaFragment on Bsda {
    ...BsdaFragment
  }
  ${bsdaFragment}
`;

export const FullBsdaFragment = gql`
  fragment FullBsda on Bsda {
    id
    isDraft
    status
    createdAt
    updatedAt
    type
    emitter {
      isPrivateIndividual
      customInfo
      company {
        ...CompanyFragment
      }
      emission {
        signature {
          author
          date
        }
      }
      pickupSite {
        address
        city
        infos
        name
        postalCode
      }
    }
    destination {
      cap
      plannedOperationCode
      company {
        ...CompanyFragment
      }
      reception {
        date
        weight
        weightIsEstimate
        refusedWeight
        acceptedWeight
        acceptationStatus
        refusalReason
      }
      operation {
        code
        mode
        description
        date
        signature {
          author
          date
        }
        nextDestination {
          company {
            ...CompanyFragment
          }
          cap
          plannedOperationCode
        }
      }
    }
    packagings {
      other
      quantity
      type
      volume
      identificationNumbers
    }
    waste {
      code
      familyCode
      materialName
      consistence
      consistenceDescription
      sealNumbers
      isSubjectToADR
      adr
      nonRoadRegulationMention
      pop
    }
    weight {
      value
      isEstimate
    }
    worker {
      isDisabled
      company {
        ...CompanyFragment
      }
      certification {
        hasSubSectionFour
        hasSubSectionThree
        certificationNumber
        validityLimit
        organisation
      }
      work {
        signature {
          author
          date
        }
      }
    }
    broker {
      company {
        ...CompanyFragment
      }
      recepisse {
        number
        department
        validityLimit
      }
    }
    transporter {
      ...FullBsdaTransporter
    }
    transporters {
      ...FullBsdaTransporter
    }
    ecoOrganisme {
      name
      siret
    }
    metadata {
      errors {
        message
        path
        requiredFor
      }
    }
    grouping {
      id
      packagings {
        other
        quantity
        type
        volume
        identificationNumbers
      }
      waste {
        code
        familyCode
        adr
        materialName
        isSubjectToADR
        sealNumbers
        nonRoadRegulationMention
      }
      destination {
        company {
          siret
          name
          orgId
        }
        cap
        operation {
          nextDestination {
            cap
            company {
              siret
              name
              orgId
            }
          }
        }
        reception {
          weight
          refusedWeight
          acceptedWeight
        }
      }
    }
    forwarding {
      id
      packagings {
        other
        quantity
        type
        volume
        identificationNumbers
      }
      waste {
        code
        familyCode
        adr
        materialName
        isSubjectToADR
        sealNumbers
        nonRoadRegulationMention
      }
      destination {
        company {
          siret
          name
          orgId
        }
        cap
        operation {
          nextDestination {
            cap
          }
        }
        reception {
          weight
          refusedWeight
          acceptedWeight
        }
      }
    }
    forwardedIn {
      id
      isDraft
      waste {
        code
        materialName
      }
      destination {
        cap
        operation {
          nextDestination {
            cap
          }
        }
        reception {
          weight
        }
      }
    }
    groupedIn {
      id
      isDraft
      waste {
        code
        materialName
      }
      destination {
        cap
        operation {
          nextDestination {
            cap
          }
        }
      }
    }
    intermediaries {
      ...CompanyFragment
    }
  }
  ${companyFragment}
  ${FullBsdaTransporterFragment}
`;
